// extracted by mini-css-extract-plugin
module.exports = {"modal":"PopupRefocusModal_modal__7VG4q"};